import { useEffect } from "react";

// Страниц стало меньше (draw-now, пересчёт воркером) — уходим на последнюю.
export const useClampPage = (
  page: number,
  pages: number,
  setPage: (page: number) => void,
) => {
  useEffect(() => {
    if (pages > 0 && page > pages) setPage(pages);
  }, [page, pages, setPage]);
};
